import { Component, Input, OnInit, ViewChildren, QueryList } from '@angular/core';
import { Subject, BehaviorSubject, timer, of, Observable } from 'rxjs';
import {
  take,
  filter,
  timeout,
  catchError,
  groupBy,
  mergeMap,
  debounceTime,
  finalize,
  exhaustMap,
  map,
  takeUntil,
} from 'rxjs/operators';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { BaseFormListComponent } from 'src/app/shared/components/base-form/base-form-list.component';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { Misc } from '../util/misc';
import { UtilService } from 'src/app/services/util.service';
import { EstimativaStaffPlanService } from '../../services/estimativa-staff-plan-service';
import { EstimativaStaffPlanCronogramaMensalService } from 'src/app/services/estimativa-staff-plan-cronograma-mensal.service';
import * as constants from 'src/app/models/constants/constants';
import { EstimativaCronogramaService } from 'src/app/services/estimativa-cronograma.service';
import {
  EstimativaStaffPlan,
  EstimativaStaffPlanTotais,
  EstimativaStaffPlanUpdate,
} from '../../models/estimativa-staff-plan.model';
import { EstimativaService } from 'src/app/services/estimativa.service';
import { ToastService } from 'src/app/services/toast.service';
import { CalculoService } from 'src/app/services/calculo.service';
import { PlanejamentoService } from 'src/app/services/planejamento.service';
import { GestaoService } from 'src/app/services/gestao.service';
import { ChangeDetectorRef, NgZone } from '@angular/core';

import {
  StaffPlanPrazoDialogComponent,
  PrazoAction,
} from './../../shared/components/staff-plan-prazo-dialog/staff-plan-prazo-dialog.component';

import { StaffPlanBridgeService, PrazoChangeEvent } from 'src/app/services/staff-plan-bridge.service';
import { StaffPlanProjetoFormComponent } from './staff-plan-projeto-form.component';

@Component({
  selector: 'app-staff-plan-projeto-list',
  templateUrl: './staff-plan-projeto-list.component.html',
  styleUrls: ['./staff-plan-projeto-list.component.scss'],
})
export class StaffPlanProjetoListComponent extends BaseFormListComponent<EstimativaStaffPlan> implements OnInit {
  @ViewChildren(MatTable) tables: QueryList<MatTable<any>>;

  @Input() estimativaId!: number;
  @Input() somenteLeitura = false;
  @Input() mostrarBotao = false;
  @Input() hiddenResume!: boolean;
  @Input() estimativaTipoId!: number;

  private destroy$ = new Subject<void>();

  tipoCronogramaChecked: boolean = false;

  displayedColumns: string[] = [
    'acoes',
    'perfil',
    'nomeProfissional',
    'custo',
    'totalHoras',
    'totalCusto',
    'estimativaStaffPlanCronogramaMensal',
  ];
  displayedColumnsTotais: string[] = [
    'perfisTotalizador',
    'totalCustoHoraTotalizador',
    'totalHorasTotalizador',
    'totalCustoTotalizador',
    'estimativaStaffPlanCronogramaMensalTotalizador',
  ];

  estimativasStaffPlan: EstimativaStaffPlan[] = [];
  dataSource = new MatTableDataSource<EstimativaStaffPlan>();
  dataSourceTotais = new MatTableDataSource<EstimativaStaffPlanTotais>();

  loading = true;
  exibirStaffPlan = false;
  tipoDelivery = false;

  qtdTotalPerfil = 0;
  totalCustoHora = 0;
  totalHoras = 0;
  totalProjeto = 0;
  totalCusto = 0;
  horasGestao = 0;
  totalAlocacao = 0;
  maxTotalAlocacao = 115;
  minTotalAlocacao = 85;
  estimativaStaffPlanCronogramaMensalTotais: any;

  isAdmin = false;
  isDelivery = false;

  savingCustoHoraId: number | null = null;
  savingHoraMesId: number | null = null;
  /** Mes (1..n) cuja descrição está em edição. */
  editingDescricaoMes: number | null = null;
  /** Mes (1..n) cuja descrição está sendo salva. */
  savingDescricaoMes: number | null = null;

  dataPrevistaInicio: string = ''; // dd/MM/yyyy
  prazoProjetoMeses: number | null = null;

  perfilTipo: any;
  estimativa: any;
  nomeProfissional: any;
  perfilDelivery: any;
  estimativaDelivery: number;
  estimativaProjeto: number;
  perfilEstimativaDelivery: any;

  private pendingSaves$ = new BehaviorSubject<number>(0);
  private readonly SAVE_IDLE_MS = 1800;
  private _idleSuccessTimer: any = null;
  private _hadErrorInSession = false;

  private custoHoraUpdate$ = new Subject<EstimativaStaffPlan>();
  private horasMensaisUpdate$ = new Subject<any>();

  private planejaSnapshot: any = null;
  private gestaoSnapshot: any = null;

  rebuilding = false;
  rebuildingMsg = 'Recalculando e gerando Staff Plan...';

  rowsHydrating = false;
  blocking = false;
  loadedOnce = false;
  tablesLoading = false;
  inlineSaving = false;

  private prazoProjetoMesesAnterior: number | null = null;
  private _warnedCantReduce = false;

  // fila para evitar replay de evento na primeira entrada da aba
  private queuedPrazoEvt: PrazoChangeEvent | null = null;

  constructor(
    protected estimativaStaffPlanService: EstimativaStaffPlanService,
    protected estimativaStaffPlanCronogramaMensalService: EstimativaStaffPlanCronogramaMensalService,
    private dialog: MatDialog,
    public misc: Misc,
    public utilService: UtilService,
    private estimativaService: EstimativaService,
    private toast: ToastService,
    private calculoService: CalculoService,
    private planejamentoService: PlanejamentoService,
    private gestaoService: GestaoService,
    private estimativaCronogramaService: EstimativaCronogramaService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    private staffPlanBridge: StaffPlanBridgeService,
  ) {
    super(estimativaStaffPlanService);
  }

  async ngOnInit() {
    this.loading = true;

    this.isAdmin = this.utilService.isAdmin();
    this.isDelivery = this.utilService.isDelivery();

    this.estimativaProjeto = constants.TipoEstimativaConstants.ID_TIPO_ESTIMATIVA_PROJETO;
    this.estimativaDelivery = constants.TipoEstimativaConstants.ID_TIPO_ESTIMATIVA_DELIVERY;

    this.perfilEstimativaDelivery = this.utilService.isDelivery() && this.estimativaTipoId === this.estimativaDelivery;

    this.definirColunasTabela();

    this.configurarDebounce();

    this.preencherHeaderDoPlanejamento(true);

    this.estimativaService.getById(this.estimativaId).subscribe((e: any) => {
      if (e?.statusId === constants.EstimativaStatusConstants.ID_ESTIMATIVA_APROVADA) {
        this.somenteLeitura = true;
      }
    });

    // primeiro load
    this.carregarStaffPlanProjeto();

    // evita que o último evento “replay” dispare aviso na 1 entrada
    this.staffPlanBridge.prazoChange$.pipe(takeUntil(this.destroy$)).subscribe((evt: PrazoChangeEvent) => {
      if (!evt || evt.estimativaId !== this.estimativaId) return;

      // ainda não carregou 1x? segura o evento
      if (!this.loadedOnce) {
        this.queuedPrazoEvt = evt;
        return;
      }

      this.handlePrazoEvent(evt);
    });
  }

  // handler centralizado
  private handlePrazoEvent(evt: PrazoChangeEvent) {
    if (evt.action === 'append' && evt.delta > 0) {
      // aplica no front (sem “forçar” o usuário) e depois recarrega do back p/ ficar exato
      this.adicionarMesesNoFinal(evt.delta, { silent: false });

      this.prazoProjetoMeses = evt.novoPrazo;
      this.prazoProjetoMesesAnterior = evt.novoPrazo;

      //recarrega do endpoint (GetByEstimativaId)
      this.recarregarStaffPlanProjeto();
      return;
    }

    if (evt.action === 'ai') {
      if (this.pendingSaves$.value > 0) {
        this.misc.mostrarAviso('Aguarde as alterações serem salvas antes de gerar com IA.');
        return;
      }

      this.planejamentoService
        .getById(this.estimativaId)
        .pipe(take(1))
        .subscribe({
          next: (p: any) => {
            const dt = this.toISODateOnly(p?.dtPrevInicio);
            const prazo = this.toNumber(p?.prazoProjetoInput);

            this.dataPrevistaInicio = this.toBRDate(p?.dtPrevInicio);
            if (prazo !== null) {
              this.prazoProjetoMeses = prazo;
              this.prazoProjetoMesesAnterior = prazo;
            }

            this.showBusy('Recalculando e atualizando Staff Plan...');
            this.misc.mostrarAviso('Recalculando e reconstruindo cronograma…');

            this.dispararErfAtualizando(
              { dtPrevInicioISO: dt ?? undefined, prazoMeses: prazo ?? undefined },
              { autoGerarCronograma: true, autoGerarRecomendacao: true },
            );
          },
          error: () => {
            this.misc.mostrarAviso('Não foi possível carregar Planejamento para gerar o Staff Plan com IA.');
          },
        });

      return;
    }

    if (evt.action === 'remove' && evt.delta < 0) {
      const qtd = Math.abs(evt.delta);

      this.removerMesesDoFinal(qtd);

      this.prazoProjetoMeses = evt.novoPrazo;
      this.prazoProjetoMesesAnterior = evt.novoPrazo;

      this.recarregarStaffPlanProjeto();
      return;
    }
  }

  // recarrega do endpoint e atualiza tela
  private recarregarStaffPlanProjeto() {
    // se quiser “silencioso”, pode não mexer em loading
    this.tablesLoading = true;
    this.loading = true;
    this.cdr.detectChanges();

    this.carregarStaffPlanProjeto();
  }

  private ddmmyyyyToISO(s: string): string | null {
    if (!s) return null;
    const p = s.split('/');
    if (p.length !== 3) return null;
    const [dd, mm, yyyy] = p;
    if (!dd || !mm || !yyyy) return null;
    return `${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}`;
  }

  private toBRDate(value: unknown): string {
    if (value == null) return '';
    let raw = String(value).trim();
    if (!raw) return '';
    if (raw.includes('T')) raw = raw.split('T')[0];

    if (/^\d{2}\/\d{2}\/\d{4}$/.test(raw)) return raw;

    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
      const [y, m, d] = raw.split('-');
      if (y === '0000' || m === '00' || d === '00') return '';
      return `${d.padStart(2, '0')}/${m.padStart(2, '0')}/${y}`;
    }

    const dt = new Date(raw);
    if (!isNaN(dt.getTime())) {
      const dd = String(dt.getDate()).padStart(2, '0');
      const mm = String(dt.getMonth() + 1).padStart(2, '0');
      const yyyy = dt.getFullYear();
      return `${dd}/${mm}/${yyyy}`;
    }
    return '';
  }

  private toNumber(v: any): number | null {
    if (v === null || v === undefined || v === '') return null;
    if (typeof v === 'number') return Number.isFinite(v) ? v : null;
    if (typeof v === 'string') {
      const n = parseFloat(v.replace(',', '.'));
      return Number.isFinite(n) ? n : null;
    }
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  }

  private configurarDebounce() {
    this.custoHoraUpdate$.subscribe((element) => this.atualizarEstimativa(element));

    this.horasMensaisUpdate$
      .pipe(
        groupBy((c: any) => this.cronKey(c)),
        mergeMap((g$) => g$.pipe(debounceTime(150))),
      )
      .subscribe((cron) => this.salvarCronograma(cron));
  }

  private startSaveActivity() {
    if (this.pendingSaves$.value === 0) this._hadErrorInSession = false;

    if (this._idleSuccessTimer) {
      clearTimeout(this._idleSuccessTimer);
      this._idleSuccessTimer = null;
    }

    this.pendingSaves$.next(this.pendingSaves$.value + 1);

    this.inlineSaving = true;
    this.cdr.detectChanges();
  }

  private finishSaveActivity() {
    const next = Math.max(0, this.pendingSaves$.value - 1);
    this.pendingSaves$.next(next);

    if (next === 0) {
      if (this._idleSuccessTimer) clearTimeout(this._idleSuccessTimer);
      this._idleSuccessTimer = setTimeout(() => {
        if (this.pendingSaves$.value === 0 && !this._hadErrorInSession) {
          this.misc.mensagemSucesso('Alterações salvas');
        }
        this.inlineSaving = false;
        this.cdr.detectChanges();
        this._idleSuccessTimer = null;
      }, this.SAVE_IDLE_MS);
    }
  }

  private salvarCronograma(cronograma: any) {
    const arred = Math.round(Number(cronograma.horasMes) * 100) / 100;

    if (cronograma._lastValorSalvo != null && Math.abs(arred - cronograma._lastValorSalvo) < 0.001) return;

    this.savingHoraMesId = cronograma.id;
    cronograma._lastValorSalvo = arred;
    cronograma.horasMes = arred;

    this.startSaveActivity();

    const isNew = !cronograma.id || cronograma.id <= 0;

    const req$ = isNew
      ? this.estimativaStaffPlanCronogramaMensalService.create(cronograma)
      : this.estimativaStaffPlanCronogramaMensalService.update(cronograma);

    req$
      .pipe(
        finalize(() => {
          this.savingHoraMesId = null;
          this.finishSaveActivity();
        }),
      )
      .subscribe({
        next: (resp: any) => {
          if (isNew && resp?.id) cronograma.id = resp.id;
          this.atualizarSomenteTotais();
        },
        error: (error) => {
          this._hadErrorInSession = true;
          this.misc.processError(error, 'Ocorreu um erro ao salvar hora mensal do profissional.');
        },
      });
  }

  onHorasMesBlur(cronograma: any) {
    const raw = (cronograma.horasMes ?? '').toString().trim();
    const valor = raw === '' ? 0 : Number(raw);
    if (isNaN(valor)) return;

    const arred = Math.round(valor * 100) / 100;

    if (cronograma._lastValorSalvo != null && Math.abs(arred - cronograma._lastValorSalvo) < 0.001) {
      cronograma.horasMes = arred;
      return;
    }

    cronograma.horasMes = arred;
    this.horasMensaisUpdate$.next(cronograma);
  }

  onCustoHoraDigitado(element: EstimativaStaffPlan) {
    const raw = parseFloat(element.custoHoraSimulacao as any);
    element.custoHoraSimulacao = isNaN(raw) ? 0 : parseFloat(raw.toFixed(2));
    element.totalCusto = element.custoHoraSimulacao * element.totalHoras;
  }

  onCustoHoraAlterado(element: EstimativaStaffPlan) {
    this.onCustoHoraDigitado(element);
    element.totalCustoHorasSimulacao = element.custoHoraSimulacao * element.totalHoras;
    this.savingCustoHoraId = element.id;
    this.custoHoraUpdate$.next(element);
  }

  onNomeProfissionalAlterado(element: EstimativaStaffPlan) {
    this.savingCustoHoraId = element.id;
    this.custoHoraUpdate$.next(element);
  }

  atualizarEstimativa(profissional: EstimativaStaffPlan) {
    if (!profissional) return;

    const payload: EstimativaStaffPlanUpdate = {
      id: profissional.id,
      estimativaId: profissional.estimativaId,
      profissionalId: profissional.profissionalId,
      nomeProfissional: profissional.nomeProfissional,
      custoHora: profissional.custoHoraSimulacao,
      totalHoras: profissional.totalHoras,
      dtInclusao: profissional.dtInclusao,
      dtAlteracao: new Date(),
    };

    this.savingCustoHoraId = profissional.id;
    this.startSaveActivity();

    this.estimativaStaffPlanService
      .updateProfissionalBasicData(payload)
      .pipe(
        finalize(() => {
          this.savingCustoHoraId = null;
          this.finishSaveActivity();
        }),
      )
      .subscribe({
        next: () => this.atualizarTotalizadores(),
        error: (error) => {
          this._hadErrorInSession = true;
          this.misc.processError(error, 'Erro ao atualizar dados do profissional.');
        },
      });
  }

  carregarStaffPlanProjeto() {
    this.estimativaStaffPlanService.getByEstimativaId(this.estimativaId).subscribe((result: any) => {
      if (result?.estimativaStaffPlanTotais) {
        this.estimativasStaffPlan = result.estimativaStaffPlan ?? [];
        this.estimativasStaffPlan.forEach((item) => {
          item.estimativaStaffPlanCronogramaMensal?.forEach((m: any) => (m._lastValorSalvo = m.horasMes));
        });

        this.rowsHydrating = true;
        this.cdr.detectChanges();
        this.dataSource.data = this.estimativasStaffPlan;
        this.finishHydration();

        this.horasGestao = this.estimativasStaffPlan.find((x) => x.profissionalId == 1)?.totalHoras ?? 0;
        this.preencherTotais(result.estimativaStaffPlanTotais, this.horasGestao);
        this.dataSource.data = [...this.estimativasStaffPlan];

        const rawDt = result.estimativaStaffPlanTotais?.dataPrevistaInicio;
        const prazoRaw = result.estimativaStaffPlanTotais?.prazoProjetoInput;

        if (rawDt) this.dataPrevistaInicio = this.toBRDate(rawDt);
        const prazoN = this.toNumber(prazoRaw);
        if (prazoN !== null) this.prazoProjetoMeses = prazoN;

        this.planejamentoService
          .getById(this.estimativaId)
          .pipe(take(1))
          .subscribe({
            next: (planeja: any) => {
              const dtP = planeja?.dtPrevInicio;
              const dtPbr = this.toBRDate(dtP);
              if (dtPbr) this.dataPrevistaInicio = dtPbr;

              const pz = this.toNumber(planeja?.prazoProjetoInput);

              if (pz !== null) {
                this.prazoProjetoMeses = pz;
                this.prazoProjetoMesesAnterior = pz;
              } else if (prazoN !== null) {
                this.prazoProjetoMesesAnterior = prazoN;
              }

              this.sincronizarCronogramaComPrazo();

              this.dataSource.data = [...this.estimativasStaffPlan];
              this.cdr.detectChanges();
              this.tables?.forEach((t) => t.renderRows());
            },
            error: () => {
              if (prazoN !== null) this.prazoProjetoMesesAnterior = prazoN;
              this.sincronizarCronogramaComPrazo();
            },
          });

        this.totalAlocacao = this.getTotalAlocacao();
        this.definirColunasTabela();
        this.exibirStaffPlan = this.estimativasStaffPlan.length > 0;
        this.tipoDelivery = this.estimativaTipoId === this.estimativaDelivery;

        // marca carregado e trata eventual evento “replay” sem mostrar aviso
        this.loadedOnce = true;

        if (this.queuedPrazoEvt) {
          const evt = this.queuedPrazoEvt;
          this.queuedPrazoEvt = null;

          if (evt.action === 'append' && evt.delta > 0) {
            this.adicionarMesesNoFinal(evt.delta, { silent: true });
            this.prazoProjetoMeses = evt.novoPrazo;
            this.prazoProjetoMesesAnterior = evt.novoPrazo;
            this.recarregarStaffPlanProjeto();
            return;
          }

          if (evt.action === 'remove' && evt.delta < 0) {
            this.removerMesesDoFinal(Math.abs(evt.delta));
            this.prazoProjetoMeses = evt.novoPrazo;
            this.prazoProjetoMesesAnterior = evt.novoPrazo;
            this.recarregarStaffPlanProjeto();
            return;
          }

          this.handlePrazoEvent(evt);
        }

        this.clearBusy();
        return;
      }

      this.exibirStaffPlan = false;

      this.preencherHeaderDoPlanejamento(true);

      this.loadedOnce = true;

      if (this.queuedPrazoEvt) this.queuedPrazoEvt = null;

      this.clearBusy();
    });
  }

  private sincronizarCronogramaComPrazo(): void {
    const prazo = this.toNumber(this.prazoProjetoMeses);
    const totais = this.estimativaStaffPlanCronogramaMensalTotais ?? [];
    const totalMeses = totais.length;

    if (!totalMeses) return;

    // Se prazo não existe/0, assume o que veio do cronograma
    if (prazo == null || prazo <= 0) {
      this.prazoProjetoMeses = totalMeses;
      this.prazoProjetoMesesAnterior = totalMeses;
      return;
    }
  }

  onPrazoProjetoFocus() {
    const atual = this.toNumber(this.prazoProjetoMeses);
    if (atual !== null) this.prazoProjetoMesesAnterior = atual;
  }

  onProjetoInicioChange() {
    if (this.somenteLeitura) return;

    const iso = this.ddmmyyyyToISO(this.dataPrevistaInicio || '');
    if (!iso) return;

    this.blocking = true;
    this.tablesLoading = true;

    this.misc.mostrarAviso('Recalculando e reconstruindo cronograma…');

    this.setRebuilding(true, 'Recalculando e atualizando Staff Plan...');
    this.cdr.detectChanges();

    this.dispararErfAtualizando(
      { dtPrevInicioISO: iso, prazoMeses: this.prazoProjetoMeses ?? undefined },
      { autoGerarCronograma: false, autoGerarRecomendacao: false },
    );
  }

  onPrazoProjetoBlur() {
    if (this.somenteLeitura) return;

    const novoPrazo = this.toNumber(this.prazoProjetoMeses);
    if (novoPrazo === null || novoPrazo < 0 || novoPrazo > 99) {
      this.misc.mostrarAviso('Prazo inválido. Informe em meses (0-99).');
      if (this.prazoProjetoMesesAnterior != null) this.prazoProjetoMeses = this.prazoProjetoMesesAnterior;
      return;
    }

    const anterior = this.prazoProjetoMesesAnterior ?? novoPrazo;
    const delta = novoPrazo - anterior;

    if (delta === 0) return;

    const msg = this.buildPrazoDialogMessage(delta);

    const dialogRef = this.dialog.open(StaffPlanPrazoDialogComponent, {
      width: '720px',
      data: { titulo: 'Alteração no Prazo do Projeto', mensagem: msg, delta },
      panelClass: 'default-dialog-container',
    });

    dialogRef.afterClosed().subscribe((action: PrazoAction) => {
      if (!action || action === 'cancel') {
        this.prazoProjetoMeses = anterior;
        return;
      }

      const normalizedAction = this.normalizePrazoAction(action, delta);

      if (normalizedAction === 'ai') {
        if (this.pendingSaves$.value > 0) {
          this.misc.mostrarAviso('Aguarde as alterações serem salvas antes de gerar com IA.');
          this.prazoProjetoMeses = anterior; // opcional: reverte
          return;
        }

        const iso = this.ddmmyyyyToISO(this.dataPrevistaInicio || '') || undefined;

        this.showBusy('Recalculando e atualizando Staff Plan...');
        this.misc.mostrarAviso('Recalculando e reconstruindo cronograma…');

        this.dispararErfAtualizando(
          { dtPrevInicioISO: iso, prazoMeses: novoPrazo },
          { autoGerarCronograma: true, autoGerarRecomendacao: true },
        );
        return;
      }

      this.persistirSomentePrazo(novoPrazo, () => {
        if (delta > 0) {
          this.adicionarMesesNoFinal(delta, { silent: false });
        } else {
          this.removerMesesDoFinal(Math.abs(delta));
        }

        this.prazoProjetoMesesAnterior = novoPrazo;

        // recarrega do back para garantir que ficou exatamente igual ao que o backend materializou
        this.recarregarStaffPlanProjeto();
      });
    });
  }

  private buildPrazoDialogMessage(delta: number): string {
    if (delta > 0) {
      return `Você aumentou o prazo do projeto em ${delta} mês(es).
Escolha como deseja continuar:

• Gerar com IA: recalcula cronograma e recomendação (pode substituir ajustes manuais).
• Manter configuração: adiciona ${delta} mês(es) no final com 0 horas.
• Cancelar: mantém o prazo anterior.`;
    }

    const abs = Math.abs(delta);
    return `Você reduziu o prazo do projeto em ${abs} mês(es).
Escolha como deseja continuar:

• Gerar com IA: recalcula cronograma e recomendação (pode substituir ajustes manuais).
• Manter configuração: remove os ${abs} último(s) mês(es) do cronograma.
• Cancelar: mantém o prazo anterior.`;
  }

  private normalizePrazoAction(action: PrazoAction, delta: number): PrazoAction {
    if (action === 'ai' || action === 'cancel') return action;

    // se o dialog já devolve explicitamente
    if (delta < 0 && action === 'remove') return 'remove';

    // se o dialog devolve sempre append para "manter configuração",
    // converte para remove quando for redução
    if (action === 'append' && delta < 0) return 'remove';

    // padrão: append
    return 'append';
  }

  // onPrazoProjetoBlur() {
  //   if (this.somenteLeitura) return;

  //   const novoPrazo = this.toNumber(this.prazoProjetoMeses);
  //   if (novoPrazo === null || novoPrazo < 0 || novoPrazo > 99) {
  //     this.misc.mostrarAviso('Prazo inválido. Informe em meses (0-99).');
  //     if (this.prazoProjetoMesesAnterior != null) this.prazoProjetoMeses = this.prazoProjetoMesesAnterior;
  //     return;
  //   }

  //   const anterior = this.prazoProjetoMesesAnterior ?? novoPrazo;
  //   const delta = novoPrazo - anterior;

  //   if (delta === 0) return;

  //   if (delta < 0) {
  //     this.misc.mostrarAviso(
  //       'No momento não é possível diminuir o prazo. Apenas aumentar (back-end não está preparado).',
  //     );
  //     this.prazoProjetoMeses = anterior;
  //     return;
  //   }

  //   const msg = `Você aumentou o prazo do projeto em ${delta} mês(es).
  //   Escolha como deseja continuar:

  //   • Gerar com IA: recalcula cronograma e recomendação (pode substituir ajustes manuais).
  //   • Manter configuração: adiciona ${delta} mês(es) no final com 0 horas.
  //   • Cancelar: mantém o prazo anterior.`;

  //   const dialogRef = this.dialog.open(StaffPlanPrazoDialogComponent, {
  //     width: '720px',
  //     data: { titulo: 'Alteração no Prazo do Projeto', mensagem: msg, delta },
  //     panelClass: 'default-dialog-container',
  //   });

  //   dialogRef.afterClosed().subscribe((action: PrazoAction) => {
  //     if (!action || action === 'cancel') {
  //       this.prazoProjetoMeses = anterior;
  //       return;
  //     }

  //     if (action === 'ai') {
  //       if (this.pendingSaves$.value > 0) {
  //         this.misc.mostrarAviso('Aguarde as alterações serem salvas antes de gerar com IA.');
  //         return;
  //       }

  //       const iso = this.ddmmyyyyToISO(this.dataPrevistaInicio || '') || undefined;

  //       this.showBusy('Recalculando e atualizando Staff Plan...');
  //       this.misc.mostrarAviso('Recalculando e reconstruindo cronograma…');

  //       this.dispararErfAtualizando(
  //         { dtPrevInicioISO: iso, prazoMeses: novoPrazo },
  //         { autoGerarCronograma: true, autoGerarRecomendacao: true },
  //       );
  //       return;
  //     }

  //     this.persistirSomentePrazo(novoPrazo, () => {
  //       this.adicionarMesesNoFinal(delta, { silent: false });
  //       this.prazoProjetoMesesAnterior = novoPrazo;
  //       this.recarregarStaffPlanProjeto();
  //     });
  //   });
  // }

  private persistirSomentePrazo(novoPrazo: number, onDone?: () => void) {
    const garantirPlaneja = (cb: (p: any) => void) => {
      if (this.planejaSnapshot?.id) return cb(this.planejaSnapshot);
      this.planejamentoService.getById(this.estimativaId).subscribe({
        next: (p: any) => {
          this.planejaSnapshot = p;
          cb(p);
        },
        error: () => this.misc.mostrarAviso('Não foi possível carregar Planeja para salvar o prazo.'),
      });
    };

    garantirPlaneja((p) => {
      if (!p?.id) {
        this.misc.mostrarAviso('Planeja sem ID. Não foi possível salvar o prazo.');
        return;
      }

      this.startSaveActivity();

      const payload = {
        ...p,
        id: p.id,
        estimativaId: this.estimativaId,
        prazoProjetoInput: novoPrazo,
      };

      this.planejamentoService
        .update(payload)
        .pipe(finalize(() => this.finishSaveActivity()))
        .subscribe({
          next: () => {
            this.misc.mensagemSucesso('Prazo atualizado.');
            onDone?.();
          },
          error: (e) => this.misc.processError(e, 'Erro ao salvar o prazo do projeto.'),
        });
    });
  }

  public adicionarMesesNoFinal(qtd: number, opts: { silent?: boolean } = {}) {
    if (!qtd || qtd <= 0) return;

    this.estimativasStaffPlan.forEach((linha: any) => {
      const arr = linha.estimativaStaffPlanCronogramaMensal ?? [];
      const lastMes = arr.length ? Math.max(...arr.map((m: any) => Number(m.mes || 0))) : 0;

      for (let i = 1; i <= qtd; i++) {
        arr.push({
          id: this.nextTmpId(),
          estimativaStaffPlanId: linha.id,
          mes: lastMes + i,
          horasMes: 0,
          _lastValorSalvo: 0,
          _isNew: true,
        });
      }

      linha.estimativaStaffPlanCronogramaMensal = arr;
    });

    const tot = this.estimativaStaffPlanCronogramaMensalTotais ?? [];
    const lastMesTot = tot.length ? Math.max(...tot.map((m: any) => Number(m.mes || 0))) : 0;

    for (let i = 1; i <= qtd; i++) {
      tot.push({
        id: this.nextTmpId(),
        mes: lastMesTot + i,
        totalHoras: 0,
        _isNew: true,
      });
    }
    this.estimativaStaffPlanCronogramaMensalTotais = tot;

    this.dataSource.data = [...this.estimativasStaffPlan];
    this.tables?.forEach((t) => t.renderRows());

    // não mostra na 1ª entrada
    if (!opts.silent) {
      this.misc.mostrarAviso(`Adicionado(s) ${qtd} mês(es) ao final do cronograma. Preencha as horas quando quiser.`);
    }
  }

  private dispararErfAtualizando(
    params: { dtPrevInicioISO?: string; prazoMeses?: number },
    opts: { autoGerarCronograma?: boolean; autoGerarRecomendacao?: boolean } = {},
  ) {
    this.setRebuilding(true, 'Recalculando ERF...');
    this.loading = true;

    const prosseguir = (planejaAtual: any, gestaoAtual: any) => {
      const p = {
        ...planejaAtual,
        inicioPlanejaHoraInput: planejaAtual.inicioPlaneja?.toFixed?.(2) ?? planejaAtual.inicioPlanejaHoraInput,
        especFuncHoraInput: planejaAtual.especFunc?.toFixed?.(2) ?? planejaAtual.especFuncHoraInput,
        especTecnicaHoraInput: planejaAtual.especTecnica?.toFixed?.(2) ?? planejaAtual.especTecnicaHoraInput,
        testeIntegraHoraInput: planejaAtual.testeIntegra?.toFixed?.(2) ?? planejaAtual.testeIntegraHoraInput,
        homologaCertiHoraInput: planejaAtual.homologaCerti?.toFixed?.(2) ?? planejaAtual.homologaCertiHoraInput,
        implantaHoraInput: planejaAtual.implanta?.toFixed?.(2) ?? planejaAtual.implantaHoraInput,
        planejacol: planejaAtual.planejacol?.toFixed?.(2) ?? planejaAtual.planejacol,
        dtPrevInicio: params.dtPrevInicioISO ?? planejaAtual.dtPrevInicio,
        prazoProjetoInput: typeof params.prazoMeses === 'number' ? params.prazoMeses : planejaAtual.prazoProjetoInput,
      };

      const g = {
        ...gestaoAtual,
        gestaoInformaHoraInput: gestaoAtual.gestaoInforma?.toFixed?.(2) ?? gestaoAtual.gestaoInformaHoraInput,
        riscoTecnicoHoraInput: gestaoAtual.riscoTecnico?.toFixed?.(2) ?? gestaoAtual.riscoTecnicoHoraInput,
        totalProjeto: gestaoAtual.totalProjeto?.toString?.() ?? gestaoAtual.totalProjeto,
        totalProjetoGestao: gestaoAtual.totalProjetoGestao?.toString?.() ?? gestaoAtual.totalProjetoGestao,
        mediaEquipe: gestaoAtual.mediaEquipe?.toString?.() ?? gestaoAtual.mediaEquipe,
        custoHora: gestaoAtual.custoHora?.toString?.() ?? gestaoAtual.custoHora,
        totalHoras: gestaoAtual.totalHoras?.toString?.() ?? gestaoAtual.totalHoras,
      };

      this.calculoService.calcularErf({ planeja: p, gestao: g }).subscribe({
        next: (resp: any) => {
          const retPlaneja = resp?.planeja ?? resp;

          this.dataPrevistaInicio = this.toBRDate(retPlaneja?.dtPrevInicio);
          const prazoN = this.toNumber(retPlaneja?.prazoProjetoInput);
          if (prazoN !== null) this.prazoProjetoMeses = prazoN;

          this.planejaSnapshot = retPlaneja;
          this.gestaoSnapshot = resp?.gestao ?? this.gestaoSnapshot;

          this.persistirPlanejaEGestaoDoERF(resp, opts);

          this.misc.mensagemSucesso('Cronograma do projeto recalculado.');
        },
        error: (err) => {
          this.misc.processError(err, 'Erro ao recalcular ERF com as novas datas.');
          this.clearBusy();
        },
      });
    };

    const garantirPlaneja = (cb: (p: any) => void) => {
      if (this.planejaSnapshot?.id) return cb(this.planejaSnapshot);
      this.planejamentoService.getById(this.estimativaId).subscribe({
        next: (p: any) => {
          this.planejaSnapshot = p;
          cb(p);
        },
        error: () => {
          this.misc.mostrarAviso('Não foi possível carregar Planeja.');
          this.clearBusy();
        },
      });
    };

    const garantirGestao = (cb: (g: any) => void) => {
      if (this.gestaoSnapshot?.id) return cb(this.gestaoSnapshot);
      this.gestaoService.getById(this.estimativaId).subscribe({
        next: (g: any) => {
          this.gestaoSnapshot = g;
          cb(g);
        },
        error: () => {
          this.misc.mostrarAviso('Não foi possível carregar Gestão.');
          this.clearBusy();
        },
      });
    };

    garantirPlaneja((p) => garantirGestao((g) => prosseguir(p, g)));
  }

  private preencherTotais(t: EstimativaStaffPlanTotais, horasGestao?: any) {
    this.qtdTotalPerfil = t.qtdTotalPerfil;
    this.totalCustoHora = t.totalCustoHora;
    this.totalHoras = t.totalHoras;
    this.totalProjeto = t.totalProjeto;
    this.totalCusto = t.totalCusto;
    const raw = t.estimativaStaffPlanCronogramaMensalTotais ?? [];
    this.estimativaStaffPlanCronogramaMensalTotais = raw.map((item: any) => ({
      ...item,
      DescricaoFase: item.descricaoFase ?? item.DescricaoFase ?? undefined,
    }));
    this.horasGestao = horasGestao ?? this.horasGestao;
    this.dataSourceTotais.data = [t];
  }

  private definirColunasTabela() {
    const isDelivery = this.estimativaTipoId === this.estimativaDelivery;
    this.displayedColumns = [
      ...(this.hiddenResume ? ['acoes'] : []),
      'perfil',
      ...(isDelivery ? ['nomeProfissional'] : []),
      'custo',
      'totalHoras',
      'totalCusto',
      'estimativaStaffPlanCronogramaMensal',
    ];
  }

  atualizarTotalizadores() {
    this.estimativaStaffPlanService.getByEstimativaId(this.estimativaId).subscribe((result: any) => {
      if (result?.estimativaStaffPlanTotais) {
        this.preencherTotais(result.estimativaStaffPlanTotais);

        this.estimativasStaffPlan = result.estimativaStaffPlan ?? [];
        this.estimativasStaffPlan.forEach((item) => {
          item.estimativaStaffPlanCronogramaMensal?.forEach((m: any) => (m._lastValorSalvo = m.horasMes));
        });

        this.dataSource.data = this.estimativasStaffPlan;

        this.rowsHydrating = true;
        this.cdr.detectChanges();
        this.finishHydration();

        this.totalAlocacao = this.getTotalAlocacao();
        this.tables?.forEach((t) => t.renderRows());
      }

      this.clearBusy();
    });
  }

  atualizarSomenteTotais() {
    this.estimativaStaffPlanService.getByEstimativaId(this.estimativaId).subscribe((res: any) => {
      this.preencherTotais(res.estimativaStaffPlanTotais);
      this.totalAlocacao = this.getTotalAlocacao();

      const novos: EstimativaStaffPlan[] = res.estimativaStaffPlan ?? [];
      this.dataSource.data.forEach((atual) => {
        const upd = novos.find((n) => n.id === atual.id);
        if (upd) {
          atual.totalHoras = upd.totalHoras;
          atual.totalCusto = upd.totalCusto;
          (atual as any).totalCustoHorasSimulacao = (upd as any).totalCustoHorasSimulacao;
        }
      });

      this.rowsHydrating = true;
      this.tables?.forEach((t) => t.renderRows());
      this.finishHydration();

      this.clearBusy();
    });
  }

  formatarMes(index: number): string {
    if (!this.dataPrevistaInicio) return `${index + 1}`;

    const p = this.dataPrevistaInicio.split('/');
    if (p.length !== 3) return `${index + 1}`;

    const [, mmStr, yyyyStr] = p;
    const yyyy = Number(yyyyStr);
    const mm = Number(mmStr);

    if (!yyyy || !mm) return `${index + 1}`;

    const dataBase = new Date(yyyy, mm - 1, 1);
    dataBase.setMonth(dataBase.getMonth() + index);

    const mes = dataBase.toLocaleString('pt-BR', { month: 'short' });
    const ano = dataBase.getFullYear().toString().slice(-2);
    return `${mes} ${ano}`;
  }

  /** Label do balão de horas: quando dataPrevistaInicio vazia/null → "Mês N - Hrs"; caso contrário → "mes ano Hrs". */
  labelBalaoHoras(index: number): string {
    const vazia = !this.dataPrevistaInicio || String(this.dataPrevistaInicio).trim() === '';
    if (vazia) return `Mês ${index + 1} - Hrs`;
    return `${this.formatarMes(index)} Hrs`;
  }

  /** Nome completo do mês em português (ex.: Janeiro, Fevereiro). Usado quando DescricaoFase não vem da API. */
  formatarNomeMesCompleto(index: number): string {
    if (index == null || index < 0 || index > 11) return '';
    const dataBase = new Date(2000, index, 1);
    const nome = dataBase.toLocaleString('pt-BR', { month: 'long' });
    return nome ? nome.charAt(0).toUpperCase() + nome.slice(1) : '';
  }

  /** Retorna o texto a exibir como label da fase. Sem idDescricaoFase: em branco. Com id e descricaoFase null: "Defina Fase". Caso contrário: o valor da descrição. */
  textoLabelFase(cronogramaMensalTotal: any): string {
    const id = cronogramaMensalTotal?.idDescricaoFase;
    if (id == null || id === undefined) return '';
    const desc = cronogramaMensalTotal?.DescricaoFase ?? cronogramaMensalTotal?.descricaoFase ?? '';
    if (desc === null || desc === undefined || String(desc).trim() === '') return 'Defina Fase';
    return String(desc).trim();
  }

  iniciarEdicaoDescricao(item: any): void {
    if (this.somenteLeitura) return;
    this.editingDescricaoMes = item?.mes ?? null;
  }

  salvarDescricaoFase(item: any, novoTexto: string): void {
    if (this.editingDescricaoMes !== (item?.mes)) {
      this.editingDescricaoMes = null;
      return;
    }
    this.editingDescricaoMes = null;
    const idDescricaoFase = item?.idDescricaoFase;
    const mes = item?.mes;
    if (idDescricaoFase == null || idDescricaoFase === undefined) {
      this.misc.mostrarAviso('Este mês não possui id de descrição da fase para alterar.');
      return;
    }
    const descricao = (novoTexto ?? '').trim();
    const anterior = (item.DescricaoFase ?? item.descricaoFase ?? '').trim();
    if (descricao === anterior) return;

    this.savingDescricaoMes = mes;
    this.estimativaStaffPlanService.updateDescricaoFase(idDescricaoFase, descricao).subscribe({
      next: () => {
        item.DescricaoFase = descricao;
        this.savingDescricaoMes = null;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.misc.processError(err, 'Erro ao salvar descrição da fase.');
        this.savingDescricaoMes = null;
        this.cdr.detectChanges();
      },
    });
  }

  getTotalAlocacao() {
    if (!this.totalProjeto) return 0;
    const totalHorasTirandoGestao = this.totalHoras - this.horasGestao;
    return (totalHorasTirandoGestao / this.totalProjeto) * 100;
  }

  private cronKey(c: any): string {
    if (c?.id && Number(c.id) > 0) return `id:${c.id}`;
    const staffId = c?.estimativaStaffPlanId ?? c?.estimativaStaffPlan?.id ?? 'x';
    const mes = c?.mes ?? 'm';
    return `tmp:${staffId}:${mes}`;
  }

  private _tmpId = -1;
  private nextTmpId() {
    return this._tmpId--;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public removerMesesDoFinal(qtd: number) {
    if (!qtd || qtd <= 0) return;

    this.estimativasStaffPlan.forEach((linha: any) => {
      const arr = linha.estimativaStaffPlanCronogramaMensal ?? [];
      linha.estimativaStaffPlanCronogramaMensal = arr.slice(0, Math.max(0, arr.length - qtd));
    });

    const tot = this.estimativaStaffPlanCronogramaMensalTotais ?? [];
    this.estimativaStaffPlanCronogramaMensalTotais = tot.slice(0, Math.max(0, tot.length - qtd));

    this.dataSource.data = [...this.estimativasStaffPlan];
    this.tables?.forEach((t) => t.renderRows());

    this.misc.mostrarAviso(`Removido(s) ${qtd} mês(es) do final do cronograma.`);
  }

  // IA recomendação
  gerarRecomendacao(identificouAlteracaoProjeto: boolean) {
    if (this.pendingSaves$.value > 0) {
      this.misc.mostrarAviso('Aguarde as alterações serem salvas antes de gerar com IA.');
      return;
    }

    this.loading = true;

    const texto = identificouAlteracaoProjeto
      ? 'Atenção! Identificamos uma alteração no Prazo do Projeto ou uma divergência entre o Total de Horas do Projeto e as horas alocadas no Staff Plan. Confirma ação?'
      : 'Atenção! Essa ação irá substituir todo Staff Plan atual. Confirma ação?';

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '580px',
      data: { titulo: 'Recomendação de Staff Plan com IA', texto },
      panelClass: 'default-dialog-container',
    });

    dialogRef.afterClosed().subscribe((ok) => {
      if (!ok) {
        this.clearBusy();
        return;
      }

      if (this.pendingSaves$.value > 0) {
        this.misc.mostrarAviso('Aguarde as alterações serem salvas antes de gerar com IA.');
        this.clearBusy();
        return;
      }

      this.misc.mostrarAviso('Recalculando e reconstruindo cronograma…');
      this.blocking = true;
      this.tablesLoading = true;

      if (identificouAlteracaoProjeto) {
        const iso = this.ddmmyyyyToISO(this.dataPrevistaInicio || '') || undefined;
        const prazo = this.toNumber(this.prazoProjetoMeses) ?? undefined;

        if (!iso && prazo === undefined) {
          this.misc.mostrarAviso('Informe data de início e/ou prazo válidos para recalcular.');
          this.clearBusy();
          return;
        }

        this.setRebuilding(true, 'Recalculando e atualizando Staff Plan...');
        this.cdr.detectChanges();

        this.dispararErfAtualizando(
          { dtPrevInicioISO: iso, prazoMeses: prazo },
          { autoGerarCronograma: true, autoGerarRecomendacao: true },
        );
        return;
      }

      this.setRebuilding(true, 'Gerando cronograma com IA...');
      this.cdr.detectChanges();

      const tipoStr: 'mensal' | 'semanal' = this.tipoCronogramaChecked ? 'semanal' : 'mensal';
      this.reconstruirIASequencial(tipoStr);
    });
  }

  private normNum(v: any): number {
    if (v === null || v === undefined || v === '') return 0;
    if (typeof v === 'number') return v;
    return parseFloat(String(v).replace(',', '.')) || 0;
  }

  private toISODateOnly(v: any): string | null {
    if (!v) return null;
    let s = String(v);
    if (s.includes('T')) s = s.split('T')[0];
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(s)) {
      const [dd, mm, yyyy] = s.split('/');
      return `${yyyy}-${mm}-${dd}`;
    }
    const d = new Date(s);
    if (isNaN(d.getTime())) return null;
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${yyyy}-${mm}-${dd}`;
  }

  private persistirPlanejaEGestaoDoERF(
    resp: any,
    opts: { autoGerarCronograma?: boolean; autoGerarRecomendacao?: boolean } = {},
  ) {
    const planejaResp = resp?.planeja ?? resp;
    const gestaoResp = resp?.gestao;

    const planejaId = this.planejaSnapshot?.id ?? planejaResp?.id;
    if (!planejaId) {
      this.misc.mostrarAviso('Não foi possível identificar o ID de Planeja para salvar.');
      this.clearBusy();
      return;
    }

    const planejaPUT = {
      id: planejaId,
      estimativaId: this.estimativaId,
      inicioPlaneja: this.normNum(planejaResp.inicioPlaneja),
      inicioPlanejaInput: this.normNum(planejaResp.inicioPlanejaInput),
      especFunc: this.normNum(planejaResp.especFunc),
      especFuncInput: this.normNum(planejaResp.especFuncInput),
      especTecnica: this.normNum(planejaResp.especTecnica),
      especTecnicaInput: this.normNum(planejaResp.especTecnicaInput),
      aceiteInterno: this.normNum(planejaResp.aceiteInterno ?? 0),
      aceiteInternoInput: this.normNum(planejaResp.aceiteInternoInput ?? 0),
      construTeste: this.normNum(planejaResp.construTeste),
      testeIntegra: this.normNum(planejaResp.testeIntegra),
      testeIntegraInput: this.normNum(planejaResp.testeIntegraInput),
      homologaCerti: this.normNum(planejaResp.homologaCerti),
      homologaCertiInput: this.normNum(planejaResp.homologaCertiInput),
      implanta: this.normNum(planejaResp.implanta),
      implantaInput: this.normNum(planejaResp.implantaInput),
      posImplanta: this.normNum(planejaResp.posImplanta),
      docCmmi: this.normNum(planejaResp.docCmmi ?? 0),
      planejacol: this.normNum(planejaResp.planejacol),
      risco: this.normNum(planejaResp.risco ?? 0),
      dtInclusao: null,
      prazoProjetoInput: this.normNum(planejaResp.prazoProjetoInput),
      dtPrevInicio: this.toISODateOnly(planejaResp.dtPrevInicio),
      estimativa: null,
    };

    const concluir = () => {
      if (opts.autoGerarCronograma || opts.autoGerarRecomendacao) {
        this.misc.mostrarAviso('Recalculando e reconstruindo cronograma…');

        this.setRebuilding(true, 'Gerando cronograma com IA...');
        this.tablesLoading = true;
        const tipoStr: 'mensal' | 'semanal' = this.tipoCronogramaChecked ? 'semanal' : 'mensal';
        this.reconstruirIASequencial(tipoStr);
      } else {
        this.tablesLoading = true;
        this.atualizarTotalizadores();
      }
    };

    this.planejamentoService.update(planejaPUT).subscribe({
      next: () => {
        if (gestaoResp?.id) {
          const gestaoPUT = {
            id: gestaoResp.id,
            estimativaId: this.estimativaId,
            gestaoInformaInput: this.normNum(gestaoResp.gestaoInformaInput),
            gestaoInforma: this.normNum(gestaoResp.gestaoInforma),
            riscoTecnicoInput: this.normNum(gestaoResp.riscoTecnicoInput),
            riscoTecnico: this.normNum(gestaoResp.riscoTecnico),
            totalProjeto: this.normNum(gestaoResp.totalProjeto),
            totalProjetoGestao: this.normNum(gestaoResp.totalProjetoGestao),
            mediaEquipe: this.normNum(gestaoResp.mediaEquipe),
            custoHora: this.normNum(gestaoResp.custoHora),
            totalHoras: this.normNum(gestaoResp.totalHoras),
          };

          this.gestaoService.update(gestaoPUT).subscribe({
            next: concluir,
            error: (e) => {
              this.misc.processError(e, 'Erro ao salvar dados de Gestão.');
              concluir();
            },
          });
        } else {
          concluir();
        }
      },
      error: (err) => {
        this.misc.processError(err, 'Erro ao salvar dados de Planejamento.');
        this.clearBusy();
      },
    });
  }

  private cronogramaExiste(res: any): boolean {
    if (!res) return false;
    const obj = res.objeto ?? res;
    return !!(
      obj?.id ||
      (Array.isArray(obj?.meses) && obj.meses.length) ||
      (Array.isArray(obj?.semanas) && obj.semanas.length) ||
      (Array.isArray(obj?.keys) && obj.keys.length)
    );
  }

  private aguardarStaffPlanCriado(maxTentativas = 10, delayMs = 1000, onFinish?: (ok: boolean) => void) {
    let tentativas = 0;
    const tentar = () => {
      this.estimativaStaffPlanService.getByEstimativaId(this.estimativaId).subscribe({
        next: (result: any) => {
          const temTotais = !!result?.estimativaStaffPlanTotais;
          const temLinhas = Array.isArray(result?.estimativaStaffPlan) && result.estimativaStaffPlan.length > 0;
          if (temTotais || temLinhas) {
            onFinish?.(true);
          } else if (++tentativas < maxTentativas) {
            setTimeout(tentar, delayMs);
          } else {
            onFinish?.(false);
          }
        },
        error: () => {
          if (++tentativas < maxTentativas) setTimeout(tentar, delayMs);
          else onFinish?.(false);
        },
      });
    };
    tentar();
  }

  private reconstruirIASequencial(tipo: 'mensal' | 'semanal' = 'mensal') {
    this.showBusy('Gerando cronograma e materializando Staff Plan...');
    this.setRebuilding(true, 'Gerando cronograma com IA...');
    this.tablesLoading = true;

    this.estimativaCronogramaService.gerarCronogramaComIA(this.estimativaId, tipo).subscribe({
      next: (res: any) => {
        if (res?.resultado === false && res?.mensagem) {
          this.misc.mostrarAviso(res.mensagem);
          this.clearBusy();
          return;
        }

        this.waitUntilTrue(
          () => this.estimativaCronogramaService.getByEstimativaId(this.estimativaId),
          (r) => this.hasCronograma(r),
          500,
          30000,
        ).subscribe((cronOk: boolean) => {
          if (!cronOk) {
            this.misc.mostrarAviso(
              'Cronograma solicitado, mas ainda não está disponível. Tente novamente em instantes.',
            );
            this.clearBusy();
            return;
          }

          this.setRebuilding(true, 'Gerando recomendação e Staff Plan...');
          this.tablesLoading = true;

          this.estimativaStaffPlanService.montarRecomendacao(this.estimativaId).subscribe({
            next: (r: any) => {
              if (r?.resultado === false && r?.mensagem) {
                this.misc.mostrarAviso(r.mensagem);
                this.clearBusy();
                return;
              }

              this.setRebuilding(true, 'Aguardando atualização do Staff Plan...');
              this.tablesLoading = true;

              this.waitUntilTrue(
                () => this.estimativaStaffPlanService.getByEstimativaId(this.estimativaId),
                (sp) => this.hasStaffPlan(sp),
                800,
                60000,
              ).subscribe((spOk: boolean) => {
                if (spOk) {
                  this.misc.mensagemSucesso('Staff Plan atualizado com sucesso.');
                  this.carregarStaffPlanProjeto();
                  return;
                }

                this.misc.mostrarAviso('Recomendação gerada. Aguardando atualização do Staff Plan...');
                this.aguardarStaffPlanCriado(20, 1500, (ok) => {
                  if (ok) {
                    this.misc.mensagemSucesso('Staff Plan realizado com sucesso.');
                    this.carregarStaffPlanProjeto();
                  } else {
                    this.misc.mostrarAviso(
                      'Recomendação gerada, mas o Staff Plan ainda não foi realizado. Clique em "Atualizar" ou aguarde alguns segundos.',
                    );
                    this.clearBusy();
                  }
                });
              });
            },
            error: (e) => {
              this.misc.processError(e, 'Erro ao gerar recomendação do Staff Plan.');
              this.clearBusy();
            },
          });
        });
      },
      error: (e) => {
        this.misc.processError(e, 'Erro ao gerar cronograma automaticamente.');
        this.clearBusy();
      },
    });
  }

  private setRebuilding(on: boolean, msg?: string) {
    this.rebuilding = on;
    if (msg) this.rebuildingMsg = msg;
    if (on) {
      this.tablesLoading = false;
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

  private finishHydration() {
    this.ngZone.onStable.pipe(take(1)).subscribe(() => {
      requestAnimationFrame(() => {
        this.tables?.forEach((t) => t.renderRows());
        this.rowsHydrating = false;

        if (this.rebuilding && !this.loading && !this.tablesLoading && !this.blocking) {
          this.setRebuilding(false);
        }
      });
    });
  }

  private waitUntilTrue<T>(
    fetch$: () => Observable<T>,
    predicate: (r: T) => boolean,
    intervalMs = 400,
    maxMs = 6500,
  ): Observable<boolean> {
    return timer(0, intervalMs).pipe(
      exhaustMap(() =>
        fetch$().pipe(
          map((r: T) => !!predicate(r)),
          catchError(() => of(false)),
        ),
      ),
      filter(Boolean),
      take(1),
      timeout({ first: maxMs }),
      catchError(() => of(false)),
    );
  }

  private hasCronograma(res: any): boolean {
    if (!res) return false;
    const obj = res.objeto ?? res;
    return !!(
      obj?.id ||
      (Array.isArray(obj?.meses) && obj.meses.length) ||
      (Array.isArray(obj?.semanas) && obj.semanas.length) ||
      (Array.isArray(obj?.keys) && obj.keys.length)
    );
  }

  private hasStaffPlan(result: any): boolean {
    const temTotais = !!result?.estimativaStaffPlanTotais;
    const temLinhas = Array.isArray(result?.estimativaStaffPlan) && result.estimativaStaffPlan.length > 0;
    return temTotais || temLinhas;
  }

  private clearBusy() {
    this.loading = false;
    this.blocking = false;
    this.tablesLoading = false;
    this.rebuilding = false;

    document.body.style.overflow = '';
    document.body.classList.remove('sp-busy');

    this.cdr.detectChanges();
  }

  private showBusy(msg = 'Recalculando e atualizando Staff Plan...') {
    this.blocking = true;
    this.rebuilding = true;
    this.rebuildingMsg = msg;
    this.tablesLoading = false;
    this.loading = false;

    this.cdr.markForCheck();
    this.cdr.detectChanges();
  }

  get isBusy(): boolean {
    return this.blocking || this.rebuilding || this.loading || this.tablesLoading;
  }

  private preencherHeaderDoPlanejamento(silent = true) {
    this.planejamentoService
      .getById(this.estimativaId)
      .pipe(take(1))
      .subscribe({
        next: (planeja: any) => {
          const dtPbr = this.toBRDate(planeja?.dtPrevInicio);
          const pz = this.toNumber(planeja?.prazoProjetoInput);

          if (dtPbr) this.dataPrevistaInicio = dtPbr;

          if (pz !== null) {
            this.prazoProjetoMeses = pz;
            this.prazoProjetoMesesAnterior = pz;
          }

          // garante render do input mesmo sem tabela
          this.cdr.detectChanges();
        },
        error: () => {
          if (!silent) this.misc.mostrarAviso('Não foi possível carregar Planejamento para preencher o cabeçalho.');
        },
      });
  }

  editarStaffPlan(element: EstimativaStaffPlan) {
    const dialogRef = this.dialog.open(StaffPlanProjetoFormComponent, {
      width: '600px',
      data: {
        estimativaId: this.estimativaId,
        staffPlan: element,
        isEdit: true,
      },
      panelClass: 'default-dialog-container',
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      // console.log('Modal fechado com resultado:', result);
      if (result === 'ok') {
        // console.log('Recarregando Staff Plan...');
        // Recarregar os dados do Staff Plan após edição
        this.carregarStaffPlanProjeto();
        // Garantir que a tabela seja atualizada após o recarregamento
        setTimeout(() => {
          this.cdr.detectChanges();
          this.tables?.forEach((t) => t.renderRows());
        }, 100);
      }
    });
  }
}
